import { useEffect, useState } from 'react';
import { isNullOrEmpty } from './common.utils';
import { useSelector } from 'react-redux';
import { selectExpenseStates } from '../store/selectors/expense.selector';
import {
  DEFAULT_PAYMENT_TYPE,
  DEFAULT_SELECT_SUBCATEGORY,
  DynamoDBFieldNames,
} from '../constants/ExpenseCategories';
import { EXPENSE_ACTION_TYPES, EXPENSE_FORM_KEYS, expenseInputTypes } from '../constants/Enums';

const useExpenseFormValidation = ({ step, actionType, subTab }) => {
  const expenseStates = useSelector(selectExpenseStates)[actionType][subTab];
  const currentSelectedSubCategory = expenseStates[DynamoDBFieldNames.SELECTED_SUBCATEGORY];
  const [isFormValid, setIsFormValid] = useState(false);

  const validateForm = () => {
    if (isNullOrEmpty(currentSelectedSubCategory?.formFields)) {
      return false;
    }

    if (currentSelectedSubCategory.SubCategoryId === DEFAULT_SELECT_SUBCATEGORY.SubCategoryId) {
      return false;
    }

    const fields = currentSelectedSubCategory.formFields[step];
    for (const field of fields) {
      // money fields should not be zero
      if (field.inputConfig.inputType === expenseInputTypes.MONEY) {
        if (parseFloat(expenseStates[field.stateName]) === 0) {
          return false;
        }
      }
      // only creation rules will block the user from submitting the expense
      const isMandatoryField = field.mandatory[EXPENSE_ACTION_TYPES.CREATION];
      if (
        (isMandatoryField && isNullOrEmpty(expenseStates[field.stateName])) ||
        (expenseStates[field.stateName] === DEFAULT_PAYMENT_TYPE.text &&
          field.inputConfig.inputType === expenseInputTypes.PAYMENT_TYPE)
      ) {
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    if (isNullOrEmpty(currentSelectedSubCategory) || isNullOrEmpty(expenseStates)) {
      setIsFormValid(false);
      return;
    }
    // if the user is in step 2 and no fields were updated, the form cannot be submitted
    if (
      step === EXPENSE_FORM_KEYS.STEP_TWO &&
      actionType === EXPENSE_ACTION_TYPES.UPDATE &&
      expenseStates.manuallyUpdatedFields?.length === 0
    ) {
      setIsFormValid(false);
      return;
    }

    setIsFormValid(validateForm());
  }, [currentSelectedSubCategory, expenseStates, step, actionType]);

  return isFormValid;
};

export default useExpenseFormValidation;
